import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1492774178719165');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      // Pixel must never crash the page (e.g. cross-origin / sandbox)
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="sunbk38ws6eh">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1492774178719165&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="su43rfcz2ye6" />
      </noscript>
      <div className="min-h-screen bg-brand-cloud text-brand-slate overflow-x-hidden selection:bg-brand-blue/20" data-id="element-2" data-mp="3ucjbrrlok7so">
        <UrgencyBanner data-id="element-3" data-mp="d2l7513lnyzs" />
        <Hero data-id="element-4" data-mp="85uivqhn5x3a" />
        <PainSection data-id="element-5" data-mp="85bbv4tj4t41" />
        <SystemSection data-id="element-6" data-mp="86w58r43y60b" />
        <LookInside data-id="element-7" data-mp="83i39jzcvyte" />
        <BonusSection data-id="element-8" data-mp="3gle88ef6yvd2" />
        <PricingCard data-id="element-9" data-mp="3gkuy3jvs9b9l" />
        <Guarantee data-id="element-10" data-mp="3gm63tp8sgt3c" />
        <Testimonials data-id="element-11" data-mp="3glnxu0wbr0i8" />
        <FAQ data-id="element-12" data-mp="3gj1w4hw47f7x" />
        <FinalCTA data-id="element-13" data-mp="3bmjsjlcitmx6" />
        <Footer data-id="element-14" data-mp="3bn30c98giuxh" />
      </div>
    </>;
}